export const reportListKeys = {
    all: ['reportLists'] as const,
    lists: () => [...reportListKeys.all, 'list'] as const,
    list: (filters: string) => [...reportListKeys.lists(), { filters }] as const,
} as const;
